import { render, staticRenderFns } from "./ChatMessageAudioControlComponent.vue?vue&type=template&id=1c5785ab&scoped=true&"
import script from "./ChatMessageAudioControlComponent.vue?vue&type=script&lang=ts&"
export * from "./ChatMessageAudioControlComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessageAudioControlComponent.vue?vue&type=style&index=0&id=1c5785ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5785ab",
  null
  
)

export default component.exports